import { render, staticRenderFns } from "./manualAllocation.vue?vue&type=template&id=1783b4a0&scoped=true"
import script from "./manualAllocation.vue?vue&type=script&lang=js"
export * from "./manualAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1783b4a0",
  null
  
)

export default component.exports